module.exports = __webpack_public_path__ + "img/fbfgd.eac1294d.png";